import { atom } from "recoil";
import { recoilPersist } from "recoil-persist";

// localStorage를 사용하여 상태를 유지
const localStorage =
  typeof window !== "undefined" ? window.localStorage : undefined;

const { persistAtom } = recoilPersist({
  key: "loginForm_local", // 저장된 키를 변경할 수 있습니다.
  storage: localStorage, // 로컬 스토리지를 사용할 수 있습니다.
});

// accessToken 상태에 대한 atom
export const accessTokenAtom = atom({
  key: "accessToken",
  default: null,
  effects_UNSTABLE: [persistAtom], // 로컬 스토리지에 저장
});

// loginFormState 상태에 대한 atom
export const loginFormState = atom({
  key: "loginFormState",
  default: {
    email: '',
    password: '',
    rememberMe: false,
  },
  effects_UNSTABLE: [persistAtom], // 로컬 스토리지에 저장
});
